import LegalPage from "./LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      testid="privacy-policy-page"
      title="Privacy Policy"
      updated="December 2025"
      sections={[
        { heading: "1. Introduction", body: ["TelstraNics respects your privacy and is committed to protecting personal data you share with us. This policy explains what we collect, how we use it, and the rights available to you."] },
        {
          heading: "2. Information We Collect",
          body: ["We collect the following categories of information:"],
          list: [
            "Contact information you provide via forms, email, chat, or during onboarding (name, email, phone, company).",
            "Project information you share to help us scope and deliver services.",
            "Usage data collected automatically from our website (pages viewed, referrer, approximate location, device).",
            "Payment information — processed by our payment providers; we do not store full card details on our servers.",
          ],
        },
        {
          heading: "3. How We Use Information",
          body: ["We use your data to:"],
          list: [
            "Respond to enquiries and provide the services you have engaged us for.",
            "Send project updates, invoices, and administrative communications.",
            "Improve our website, marketing, and service offerings.",
            "Comply with legal obligations and enforce our Terms of Use.",
          ],
        },
        { heading: "4. Sharing & Third Parties", body: ["We do not sell personal information. We may share limited data with trusted providers (hosting, analytics, email, payments) under confidentiality obligations, and only to the extent necessary to deliver our services."] },
        { heading: "5. Cookies & Tracking", body: ["We use cookies and similar technologies for essential site functionality, analytics, and marketing measurement. You can control cookies via your browser settings."] },
        { heading: "6. Data Retention & Security", body: ["We retain personal data only as long as necessary for the purposes above or as required by law. We employ industry-standard safeguards, though no method of transmission is 100% secure."] },
        {
          heading: "7. Your Rights",
          body: ["Depending on your jurisdiction, you may have the right to:"],
          list: ["Access, correct, or delete your personal data.", "Object to or restrict certain processing.", "Withdraw consent where processing is based on consent.", "Lodge a complaint with a supervisory authority."],
        },
        { heading: "8. Contact", body: ["For privacy requests or questions, email privacy@telstranics.com."] },
      ]}
    />
  );
}
